import {HttpExclude, Request, RequestExpose} from '@simpli/serialized-request'
import {PageCollection} from '@simpli/resource-collection'
import {GithubRepositoryLanguage} from '@/model/resource/GithubRepositoryLanguage'

@HttpExclude()
export class GithubRepositoryLanguageCollection extends PageCollection<
  GithubRepositoryLanguage
> {
  resource?: IGithubRepositoryLanguageCollectionResourcesHolder

  @RequestExpose() idOrganizationFk: number | null = null
  @RequestExpose() idGithubRepositoryFk: number | null = null

  constructor() {
    super(GithubRepositoryLanguage)
  }

  queryAsPage() {
    return this.listGithubRepositoryLanguage()
  }

  async listGithubRepositoryLanguage() {
    return await Request.get(`/client/github-repository-language`, {
      params: this.params,
    })
      .name('listGithubRepositoryLanguage')
      .as(this)
      .getResponse()
  }

  async sumByOrganization() {
    return await Request.get(
      `/client/github-repository-language/sum-by-organization`,
      {
        params: this.params,
      }
    )
      .name('sumGithubRepositoryLanguageByOrganization')
      .as(this)
      .getResponse()
  }
}

export interface IGithubRepositoryLanguageCollectionResourcesHolder {}
